var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 87C70.2107 87 87 70.2107 87 49.5C87 28.7893 70.2107 12 49.5 12C28.7893 12 12 28.7893 12 49.5C12 70.2107 28.7893 87 49.5 87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4888 13.2223C26.4604 12.4322 27.6614 12 29.1031 12C30.7828 12 32.2483 12.8797 33.3858 14.1845C34.5222 15.4881 35.3969 17.2808 35.9433 19.3255C36.0959 19.8971 35.7564 20.4844 35.1847 20.6372C34.613 20.7899 34.0258 20.4503 33.873 19.8786C33.3875 18.0615 32.6391 16.5889 31.7705 15.5926C30.9031 14.5976 29.9819 14.1429 29.1031 14.1429C28.122 14.1429 27.4063 14.4249 26.8408 14.8848C26.2547 15.3615 25.7643 16.0839 25.3526 17.0594C24.5147 19.045 24.1307 21.7445 23.7264 24.6478L23.7123 24.7488C23.325 27.5308 22.9114 30.5009 21.953 32.7734C21.4607 33.9408 20.7941 35.0041 19.8437 35.7775C18.8725 36.5677 17.6719 37 16.2306 37H16.2258C15.5203 36.9969 14.8239 36.8417 14.1838 36.5452C13.6469 36.2964 13.4133 35.6595 13.662 35.1227C13.9107 34.5858 14.5476 34.352 15.0846 34.6008C15.4446 34.7677 15.8362 34.855 16.233 34.8572C17.2122 34.8567 17.9266 34.5748 18.4912 34.1153C19.077 33.6388 19.5671 32.9164 19.9785 31.9408C20.816 29.9552 21.1997 27.2555 21.604 24.3522L21.6176 24.2546C22.0051 21.4715 22.4189 18.4998 23.3783 16.2263C23.8709 15.059 24.5379 13.9956 25.4888 13.2223Z",
    fill: "#0397AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.6e42d1c72c2789c42ce0bbd87a7babb3.svg";
export { ForwardRef as ReactComponent };